import { isEmpty } from 'lodash-es'
import { useSelector } from 'react-redux'
import { isExpired } from 'src/utils/auth'

const useUserSession = () => {
  const { userInfo } = useSelector((state) => state.auth)

  let authenticated = true

  if (isEmpty(userInfo) || (isExpired('token') && isExpired('refreshToken'))) {
    return { authenticated: false, userInfo: null }
  }

  return { authenticated, userInfo }
}

export default useUserSession
